// The visitor's own chat (functions/_lib/webChats.js): its key and the last message they have seen, kept in
// this browser so the chat carries on from page to page and the team's replies reach them.
const KEY = 'kg-chat';
// A chat untouched this long starts afresh.
const KEEP_MS = 7 * 24 * 3600 * 1000;

export function loadChat() {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (!saved?.key || Date.now() - (saved.at || 0) > KEEP_MS) return null;
    return saved;
  } catch { return null; }
}

export function saveChat(patch) {
  try {
    const next = { ...(loadChat() || {}), ...patch, at: Date.now() };
    localStorage.setItem(KEY, JSON.stringify(next));
    return next;
  } catch { return null; }
}

export function forgetChat() {
  try { localStorage.removeItem(KEY); } catch { /* private window */ }
}
